import Add16 from '@carbon/icons-react/es/add/16';
import Upload16 from '@carbon/icons-react/es/upload/16';
import { InputProps } from 'antd';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { SearchInput } from 'components/atoms/input';
import { ActionBar } from 'components/molecules/action-bar';
import { PermissionRuleName } from 'constant';

const StyledActionBar = styled(ActionBar)`
  padding: var(--spacing-03) 0 !important;
  position: sticky;
  top: 0;
  z-index: var(--zindex-layer-02);
  background: var(--white-100);
  box-shadow: var(--shadow-02);
`;

const UploadButton = styled(Button)`
  margin-left: var(--spacing-03);
`;

const StyledSearchInput = styled(SearchInput)`
  margin-right: var(--spacing-03);
`;

const CreateFolderButton = styled(Button)`
  color: var(--primary-color);
  border-color: var(--primary-color);
  &:hover {
    color: var(--white-100);
    background: var(--primary-color);
  }
`;

export const FileActionHeader = ({
  onCreateGroupClick,
  onUploadClick,
  searchInput,
  onSearchInputChange,
}: {
  onCreateGroupClick: VoidFunction;
  onUploadClick: VoidFunction;
  searchInput: string;
  onSearchInputChange: (value) => void;
}) => {
  const _onSearchInputChange: InputProps['onChange'] = useCallback(
    (e) => {
      onSearchInputChange(e.target.value);
    },
    [onSearchInputChange],
  );

  return (
    <StyledActionBar>
      <ActionBar.Primary>
        {/**
         * hides filter button since it is non functional
         */}
        {/* <TaskFilterButton size="small" type="link">
          <FormattedMessage id="filter" />
        </TaskFilterButton> */}
      </ActionBar.Primary>
      <ActionBar.Secondary>
        <StyledSearchInput
          direction="right"
          searchButtonProps={{ type: 'text' }}
          placeholder="search"
          size="small"
          onChange={_onSearchInputChange}
          value={searchInput}
        />
        <CreateFolderButton
          data-cy="project.files.create.folder.button"
          size="small"
          icon={<Add16 />}
          iconPlacement="right"
          onClick={onCreateGroupClick}
          ruleName={PermissionRuleName.FileGroupCreateAction}
        >
          <FormattedMessage id="project.files.create.folder.button" />
        </CreateFolderButton>
        <UploadButton
          data-cy="upload"
          size="small"
          type="primary"
          icon={<Upload16 />}
          iconPlacement="right"
          onClick={onUploadClick}
          ruleName={PermissionRuleName.FileUploadAction}
        >
          <FormattedMessage id="upload" />
        </UploadButton>
      </ActionBar.Secondary>
    </StyledActionBar>
  );
};
